import React from 'react';
import {
  List,
  Responsive,
  SimpleList,
  ReferenceField,
  Datagrid,
  TextField,
  EditButton
} from 'react-admin'
import LayerFilter from './LayerFilter'

const small = (
  <SimpleList
    primaryText={record => record.title}
    secondaryText={record => `${record.views} views`}
    tertiaryText={record => new Date(record.published_at).toLocaleDateString()}
    />
)

const medium = (
  <Datagrid>
    <TextField source="name" />
    <ReferenceField label="User" source="userId" reference="users" >
      <TextField source="email" />
    </ReferenceField>
    <EditButton />
  </Datagrid>
)

const LayerList = (props) => (
  <List {...props} filters={<LayerFilter />} >
    <Responsive
      small={small}
      medium={medium}
      />
  </List>
);

export default LayerList



// WEBPACK FOOTER //
// ./src/components/FileList.js